import Container from '@mui/material/Container'
import { AdvantageBlockItem, AdvantageBlocks } from '@repo/shared-core-ui-components/AdvantageBlocks'
import Iconify from '@repo/shared-core-ui-components/Iconify/iconify'

export function DashboardFeaturesAdvantageBlocks() {
  const content: AdvantageBlockItem[] = [
    {
      title: 'Fully Customizable',
      icon: <Iconify icon={'ic:baseline-star-border'} width={88} />,
      text: 'Arrange your dashboard exactly how you want.'
    },
    {
      title: 'Powerful Widgets',
      icon: <Iconify icon={'ic:outline-thumb-up'} width={88} />,
      text: 'Prebuilt widgets built from the perspective of the avid trader.'
    }
  ]

  return (
    <Container sx={{ maxWidth: '1660px' }} maxWidth={false}>
      <AdvantageBlocks content={content} />
    </Container>
  )
}
